export default __webpack_public_path__ + "static/media/camiseta_imagem.666c1cb1.svg";